import React, {Component} from 'react';
import {getSubFormFieldByType, sanitizeFieldName} from "../../util/methods";
import {AutoComplete, Button, Checkbox, Form, Icon, message, Popover, Select, Typography, Upload} from 'antd';
import SubList from "../../components/SubList";
import moment from 'moment';

const {Text} = Typography;

class Assets extends Component {
  id = 0;
  state = {
    keys: [],
    willUpload: false,
    fileList: [],
    uploading: false,
    docs: [],
  };

  componentDidMount() {
    const {data = [{}]} = this.props;
    this.setState({
      keys: [{}],
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
    //console.log(nextProps.contractUploading, this.props.contractUploading);
    if (nextProps.contractUploading !== this.props.contractUploading) {
      this.setState({
        uploading: nextProps.contractUploading,
      })
    }
    // console.log(nextProps.docData, this.props.docData);
    if (nextProps.docData !== this.props.docData) {
      this.setState({
        docs: nextProps.docData,
      })
    }
  }

  remove = index => {
    const {keys} = this.state;
    const {form, item} = this.props;
    const {field} = item;
    if (keys.length === 0) {
      return;
    }
    const val = form.getFieldValue(field);
    val.splice(index, 1);

    keys.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const {item: {field}} = this.props;
    const {keys} = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  handleUpload = () => {
    const {fileList} = this.state;
    const formData = new FormData();
    fileList.forEach(file => {
      formData.append('files[]', file);
    });
    // formData.append(key, payload[key]);
    console.log(fileList)

    const vendor = this.props.form.getFieldValue('vendor');
    const saleDate = this.props.form.getFieldValue('saleDate');

    if (!vendor || !moment(saleDate).isValid())
      message.error("Please add sale details first");
    else {
      this.setState({
        uploading: true,
      });


      // data.documents = this.props && this.props.data && this.props.data.documents;


      this.props.createResourceWithExcel(fileList, {
        documents: this.props && this.props.docData,
        assetUpload: true,
        vendor,
        saleDate
      });
    }

    // axios.post(`/contract`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}})
    //   .then((response) => {
    //     console.log(response);
    //     this.setState({
    //       fileList: [],
    //       uploading: false,
    //     });
    //     message.success('upload successfully.');
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     this.setState({
    //       uploading: false,
    //     });
    //     message.error('upload failed.');
    //   });
  };

  onChangeUploadBtn = (e) => {
    this.props.disableCreateBtn(e.target.checked);
    this.setState({
      willUpload: e.target.checked
    },()=>this.props.toggleUpload(e.target.checked))
  }

  templateContent = (
    <div>
      <p>CSV file template</p>
      <Button size={'small'} onClick={() => {
        window.open('../csv_template/SaleAssetsTemplate.csv', '_blank');
      }}>Download</Button>
    </div>
  );

  render() {
    const {getFieldDecorator, getFieldValue, getFieldsValue, setFieldsValue} = this.props.form;
    const {form, item, data = [], hideAddButton = false, resource, superMaster, subMaster} = this.props;
    // const {field} = item;
    const {keys} = this.state;
    const style = {
      marginTop: '10px',
      // border: '5px solid #000',
      padding: '20px',
      // borderRadius: '9px',
      borderStyle: 'none none none solid',
      borderColor: '#038fde',
      borderWidth: '10px'
    };

    const {uploading, fileList} = this.state;
    const uploadProps = {
      accept: '.csv',
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [/*...state.fileList,*/ file],
        }));
        return false;
      },
      fileList,
    };


    return (
      <div>
        <div><Checkbox onChange={this.onChangeUploadBtn}>
          <Text>Upload Assets</Text>
        </Checkbox><Popover content={this.templateContent} title="" trigger="click">
          <Button type="default" shape="circle" icon="download" size={'small'}/>
        </Popover></div>
        {
          this.state.willUpload &&
            <div>
              <Upload {...uploadProps}><Button><Icon type="upload"/>Upload Excel</Button></Upload><Button
              type="primary"
              onClick={this.handleUpload}
              disabled={fileList.length === 0}
              loading={uploading || this.props.loading}
              style={{marginTop: 16}}
            >
              {uploading ? 'Uploading' : 'Start Upload'}
            </Button></div>
        }

      </div>

    );
  }
}

Assets.propTypes = {};

export default Assets;
